import { t } from "@web-monorepo/i18n/macro";
import createAction from "@web-monorepo/infra/createAction";
import { getImageSrc } from "@web-monorepo/static-assets";
import { AppMetadata } from "src/pods/toolkitData/components/EditableSetup";

const icon = getImageSrc("toolkit/src/pods/today/assets/logo.svg");

export const appMetadataToday = (): AppMetadata => ({
  href: "today",
  title: t`Today`,
  variant: "today",
  icon,
});

export type TodayNotes = {
  text?: string;
  title?: string;
};

export const RECEIVE_NOTES = createAction("RECEIVE_NOTES");
